import React from "react";

import {
  BILLING_ITEM_TYPE_LABELS,
  PAYMENT_STATUS_STYLES,
  RENEWAL_STATUS_STYLES,
} from "../data/subscriptionOptions";

import {
  getPaymentStatusLabel,
  getRenewalStatusLabel,
} from "../utils/subscriptionFormatters";

const BASE_CLASSES =
  "inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold";

export function PaymentStatusBadge({
  status,
  className = "",
}) {
  const style =
    PAYMENT_STATUS_STYLES[status] ||
    PAYMENT_STATUS_STYLES.pending;

  return (
    <span
      className={`${BASE_CLASSES} ${style} ${className}`}
    >
      {getPaymentStatusLabel(status)}
    </span>
  );
}

export function RenewalStatusBadge({
  status,
  className = "",
}) {
  const style =
    RENEWAL_STATUS_STYLES[status] ||
    RENEWAL_STATUS_STYLES.not_started;

  return (
    <span
      className={`${BASE_CLASSES} ${style} ${className}`}
    >
      {getRenewalStatusLabel(status)}
    </span>
  );
}

export function BillingItemTypeBadge({
  itemType,
  className = "",
}) {
  const isOneTime = itemType === "one_time";

  const style = isOneTime
    ? "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700 dark:border-fuchsia-900/60 dark:bg-fuchsia-950/30 dark:text-fuchsia-300"
    : "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-900/60 dark:bg-indigo-950/30 dark:text-indigo-300";

  return (
    <span
      className={`${BASE_CLASSES} ${style} ${className}`}
    >
      {BILLING_ITEM_TYPE_LABELS[itemType] ||
        "Abonnement annuel"}
    </span>
  );
}

export function LifecycleStatusBadge({
  status,
  className = "",
}) {
  return (
    <span
      className={`${BASE_CLASSES} border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 ${className}`}
    >
      {status || "Non renseigné"}
    </span>
  );
}